export default{
    
    lista:{
        method:'get',
        url:'rubrica/lista'
    },
    pesquisa:{
        method:'get',
        url:'rubrica/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'rubrica/cadastro'
    },
    delete:{
        method:'delete',
        url:'rubrica/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'rubrica/editar{/id}'
    },
    update:{
        method:'post',
        url:'rubrica/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    }
}